<template>
  <b-container class="bv-example-row" fluid>
    <b-row align-h="end">
      <b-button variant="success" @click="openFieldModal">
        เพิ่มข้อมูล
      </b-button>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="items"
      >
        <template slot="id" slot-scope="data">
          <div class="col-right">
            {{ data.item.id }}
          </div>
        </template>
        <template slot="name" slot-scope="data">
          <div class="col-left">
            {{ data.item.name }}
          </div>
        </template>
        <template slot="position" slot-scope="data">
          <div class="col-left">
            {{ data.item.position }}
          </div>
        </template>
        <template slot="username" slot-scope="data">
          <div class="col-left">
            {{ data.item.username }}
          </div>
        </template>
        <template slot="created_at" slot-scope="data">
          <div class="col-center">
            {{ data.item.created_at }}
          </div>
        </template>
        <template slot="is_active" slot-scope="data">
          <b-badge :variant="data.item.is_active ? 'success' : 'danger'">
            {{ data.item.is_active ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <template slot="user_group_id" slot-scope="data">
          <div class="col-left">
            {{ data.item.user_group.name }}
          </div>
        </template>
        <template slot="action" slot-scope="data">
          <!--          <b-container fluid>-->
          <b-row>
            <b-col>
              <b-button variant="warning" @click="openFieldModal(data.item.id)">
                แก้ไข
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="danger" @click="openDeleteModal(data.item.id)">
                ลบ
              </b-button>
            </b-col>
          </b-row>
          <!--          </b-container>-->
        </template>
      </b-table>
    </b-row>
    <!--    <b-modal-->
    <!--        ref="inputModal"-->
    <!--        :title="modalTitle"-->
    <!--        @ok="submit"-->
    <!--        @shown="clearInputField"-->
    <!--    >-->
    <sweet-modal ref="inputModal">
      <input-modal :fields.sync="inputFields" />
      <b-row>
        <b-col cols="auto">
          <b-button variant="success" @click="submit">
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button @click="$refs['inputModal'].close()">
            ยกเลิก
          </b-button>
        </b-col>
      </b-row>
    </sweet-modal>

    <!--    </b-modal>-->
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delUser"
    >
      <confirm-modal v-model="password" />
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import InputModal from "../../components/Settings/InputModal";
import ConfirmModal from "../../components/Settings/ConfirmModal";

export default {
  name: "User",
  components: {
    InputModal,
    ConfirmModal,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          isInputField: false,
        },
        {
          key: "name",
          label: "NAME",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },
        {
          key: "position",
          label: "POSITION",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },
        {
          key: "username",
          label: "USERNAME",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },
        {
          key: "user_group_id",
          label: "USER GROUP",
          isInputField: true,
          isSpecialField: true,
          fieldType: "selected",
          resources: [],
        },
        {
          key: "is_active",
          label: "ACTIVE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "checkbox",
        },
        {
          key: "created_at",
          label: "DATE CREATED",
          isInputField: false,
        },
        {
          key: "action",
          label: "ACTIONS",
          isInputField: false,
        },
      ],
      createInputFields: [
        {
          key: "name",
          label: "Name",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "position",
          label: "POSITION",
          isInputField: true,
          isSpecialField: false,
          required: false,
          fieldType: "text",
        },
        {
          key: "username",
          label: "Username",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "password",
          label: "Password",
          fieldType: "password",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "user_group_id",
          label: "User Group",
          fieldType: "selected",
          resources: [],
          textField: "name",
          valueField: "id",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "is_active",
          label: "Active",
          fieldType: "checkbox",
          value: false,
          required: false,
          default: false,
        },
      ],
      updateInputFields: [
        {
          key: "name",
          label: "Name",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "position",
          label: "POSITION",
          isInputField: true,
          isSpecialField: false,
          required: false,
          fieldType: "text",
        },
        {
          key: "username",
          label: "Username",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "user_group_id",
          label: "User Group",
          fieldType: "selected",
          resources: [],
          textField: "name",
          valueField: "id",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "is_active",
          label: "Active",
          fieldType: "checkbox",
          value: false,
          required: false,
          default: false,
        },
      ],
      inputFields: [],
      items: [],
      itemSelected: null,
      modalTitle: "",
      deleteUserIdSelected: null,
      password: "",
    };
  },
  methods: {
    ...mapActions({
      getUsers: "Settings/getUserList",
      getUserGroups: "Settings/getUserGroupList",
      createUser: "Settings/createUser",
      updateUser: "Settings/updateUser",
      deleteUser: "Settings/deleteUser",
    }),
    async openFieldModal(userId = null) {
      this.itemSelected =
        this.items.find((item) => {
          return item.id === userId;
        }) || null;

      let userGroupIndex = this.inputFields.findIndex((field) => {
        return field.key === "user_group_id";
      });
      this.clearInputField();

      if (userGroupIndex >= 0) {
        this.inputFields[userGroupIndex].resources = await this.getUserGroups();
      }
      this.inputFields = this.itemSelected
        ? this.updateInputFields
        : this.createInputFields;
      this.$refs["inputModal"].open();
    },
    async openDeleteModal(userId) {
      this.deleteUserIdSelected = userId;
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.password = password;
        this.delUser();
      } else {
        this.password = "";
        return;
      }
      // this.$refs['confirmDelete'].show();
    },
    async submit(evnt) {
      // evnt.preventDefault()
      let payload = {};
      let malformedCheck = false;
      this.inputFields.forEach((el) => {
        if (el.value === null || el.value === "" || el.value === undefined) {
          if (!el.required) {
            payload[el.key] = el.default;
          } else {
            malformedCheck = true;
            this.$swal.fire("กรอกข้อมูลไม่ครบ");
          }
        } else {
          payload[el.key] = el.value;
        }
      });

      if (malformedCheck) {
        // this.$refs['inputModal'].show();
        return;
      }
      this.$refs["inputModal"].close();
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.password = password;
      } else {
        this.password = "";
        this.$refs["inputModal"].open();
        return;
      }

      this.$store.state.isLoading = true;
      if (this.itemSelected) {
        try {
          var res = await this.updateUser({
            payload,
            id: this.itemSelected.id,
            password: this.password,
          });
        } catch (err) {
          this.password = "";
          this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
          this.$store.state.isLoading = false;
          return;
        }
      } else {
        try {
          await this.createUser({ ...payload, password: this.password });
        } catch (err) {
          this.password = "";
          this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
          this.$store.state.isLoading = false;
          return;
        }
      }

      try {
        this.items = await this.getUsers();
      } catch (err) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
        this.$store.state.isLoading = false;
        return;
      }
      this.itemSelected = null;
      this.password = "";
      this.$swal.fire("บันทึกเสร็จสิ้น");
      this.$store.state.isLoading = false;
      this.$nextTick(() => {
        this.$refs["inputModal"].close();
      });
    },
    clearInputField() {
      if (this.itemSelected) {
        this.inputFields.forEach((el) => {
          el.value = this.itemSelected[el.key];
        });
      } else {
        this.inputFields.forEach((el) => {
          el.value = "";
        });
      }
      this.modalTitle = this.itemSelected ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล";
    },
    async delUser() {
      this.$store.state.isLoading = true;
      try {
        let res = await this.deleteUser({
          id: this.deleteUserIdSelected,
          password: this.password,
        });
      } catch (err) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.deleteUserIdSelected = null;
      this.password = "";
      try {
        this.items = await this.getUsers();
      } catch (err) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
        this.$store.state.isLoading = false;
        return;
      }
      this.$refs["confirmDelete"].hide();
      await this.$swal.fire("เสร็จสิ้น", "ลบผู้ใช้สำเร็จ", "success");
      this.$store.state.isLoading = false;
    },
  },
  async mounted() {
    this.items = await this.getUsers();
  },
};
</script>

<style scoped></style>
